import sv from "./locales/sv.json";
import da from "./locales/da.json";
import fr from "./locales/fr.json";
import nl from "./locales/nl.json";
import no from "./locales/no.json";
const dictionaries = {sv, da, fr, nl, no};
let activeLocale = "de";
export const setActiveLocale = (locale) => { activeLocale = locale; };
const templateCache = {};
const protectedNames = new Set(["Lulu Lehrer", "Swiss Blockchain Alliance", "Joseph Buxbaum", "Marius Ratzenberger", "Odetta Untermann", "Veronika Ehrenreich", "Bastian Ehrenfeld", "Frank Morel", "Eric Larson", "Steffen Kirchwey", "Josephine Hengsbach", "Karl Hochheim", "Jochen Mittermaier", "Helena Höller", "Matteo Schürmann", "Victor Börner", "Nora Finck", "Christian Scheider", "Dora Metzinger", "Diego Benz", "Guido Bühler", "Chris Bruppacher", "Dr. Daniel Diemers", "Christoph Drexl", "Martin Hess", "Dominic Nazareno", "Prof. Dr. Jur. Rolf H. Weber", "Dr. Mattia Rattaggi"]);
const escape = (value) => value.replace(/[.*+?^$()|[\]\\]/g, "\\$&");
export const translateText = (value, locale = activeLocale) => {
  if (typeof value !== "string" || !dictionaries[locale]) return value;
  const normalized = value.trim().replace(/\s+/g, " ");
  if (protectedNames.has(normalized)) return value;
  const dict = dictionaries[locale];
  let result = dict[normalized];
  if (result === undefined) {
    const templates = templateCache[locale] || (templateCache[locale] = Object.entries(dict).filter(([key]) => key.includes("__VAR") && /[A-Za-zÀ-ž]/.test(key.replace(/__VAR\d+__/g, ""))).sort(([a], [b]) => b.replace(/__VAR\d+__/g, "").length - a.replace(/__VAR\d+__/g, "").length).map(([key, translated]) => ({regex: new RegExp("^" + key.split(/(__VAR\d+__)/).map(part => /^__VAR\d+__$/.test(part) ? "(.+?)" : escape(part)).join("") + "$"), translated})));
    for (const {regex, translated} of templates) {
      const match = normalized.match(regex);
      if (match) { result = translated.replace(/__VAR(\d+)__/g, (_, i) => match[Number(i)+1]); break; }
    }
  }
  if (result === undefined) return value;
  return (value.match(/^\s*/)?.[0] || "") + result + (value.match(/\s*$/)?.[0] || "");
};
export const localize = (value) => translateText(value);
const stableKeys = new Set(["id", "slug", "img", "code", "lang", "email", "phones", "phoneHrefs", "street", "city", "portal", "no"]);
export const translateTree = (value, locale) => {
  if (typeof value === "string") return translateText(value, locale);
  if (typeof value === "function") return (...args) => translateTree(value(...args), locale);
  if (Array.isArray(value)) return value.map(item => translateTree(item, locale));
  if (value && typeof value === "object") return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, stableKeys.has(key) ? item : translateTree(item, locale)]));
  return value;
};
